import { useState } from "react";
import { api, apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Search } from "lucide-react";

const money = (v) => (v == null ? "—" : `$${Number(v).toFixed(2)}`);

// Read-only report (master admin). It changes nothing: the customer decides which price table is right.
export function LmsPriceDisagreements() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = async () => {
    setBusy(true);
    try { setData(await api.get("/admin/lms-price-disagreements")); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div className="mt-8 max-w-3xl rounded-lg border border-border bg-card p-5 space-y-3" data-testid="lms-price-report-card">
      <h3 className="font-heading font-bold">Écarts de prix LMS</h3>
      <p className="text-sm text-muted-foreground">Rapport en lecture seule. Les <b>nouvelles factures LMS</b> utilisent la colonne « Prix LMS par niveau » (Boutique scolaire &amp; Frais). Les deux autres colonnes sont la liste « Cours LMS » de la Boutique et le total de la liste « Frais de cours ». Aucune modification n'est faite ici.</p>
      <Button variant="outline" onClick={load} disabled={busy} data-testid="lms-price-report-load-btn"><Search className="h-4 w-4 mr-1" />{data ? "Actualiser" : "Afficher le rapport"}</Button>
      {data && (
        <div className="space-y-2" data-testid="lms-price-report-result">
          <p className="text-xs text-muted-foreground" data-testid="lms-price-report-summary">{data.levels_differing === 0 ? "Les trois sources sont d'accord pour tous les niveaux." : `${data.levels_differing} niveau(x) avec un écart (surlignés).`}</p>
          <div className="overflow-x-auto rounded border border-border">
            <table className="w-full text-sm">
              <thead className="bg-muted/50 text-left text-xs">
                <tr><th className="p-2">Niveau</th><th className="p-2 text-right">Prix LMS par niveau (facturé)</th><th className="p-2 text-right">Cours LMS</th><th className="p-2 text-right">Total Frais de cours</th></tr>
              </thead>
              <tbody>
                {data.rows.map((r) => (
                  <tr key={r.level} className={r.differs ? "bg-amber-50 font-medium" : ""} data-testid={`lms-price-row-${r.level}`} data-differs={r.differs ? "1" : "0"}>
                    <td className="p-2">{r.level}</td>
                    <td className="p-2 text-right">{money(r.lms_prices)}</td>
                    <td className="p-2 text-right" title={r.lms_courses_entry || ""}>{r.lms_courses_matches === 1 ? money(r.lms_courses) : <span className="text-red-700 text-xs">{r.lms_courses_matches === 0 ? "aucune ligne" : `${r.lms_courses_matches} lignes`}</span>}</td>
                    <td className="p-2 text-right">{money(r.course_fees_sum)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
